module.exports = __webpack_public_path__ + "static/media/flower.c678ec4a.svg";